import { apiClient } from "./base.service";

const metricsService = {
  get: async () => await apiClient.get("/metrics"),
  getByTeacher: async (id: string) =>
    await apiClient.get("/metrics/teacher/" + id),
};

export default metricsService;
